import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  // ✅ Load previously selected company (if exists)
  const [selectedCompany, setSelectedCompany] = useState(() => {
    const saved = localStorage.getItem("selectedCompany");
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        return null;
      }
    }
    const id = localStorage.getItem("companyId");
    const name = localStorage.getItem("companyName");
    if (id && name) {
      return { id, name };
    }
    return null;
  });

  // ✅ Function to update company globally + persist in localStorage
  const updateCompany = useCallback((company) => {
    if (company) {
      const compId = company.id || company.CompID;
      const compName = company.name || company.Name;
      const compColor = company.CompanyColourCode || company.color || "#000000";
      const formatted = {
        id: compId,
        name: compName,
        LogoPath: company.LogoPath || null,
        CompanyColourCode: compColor,
      };

      setSelectedCompany((prev) => {
        const prevId = prev?.id || prev?.CompID;
        if (
          prevId &&
          compId &&
          String(prevId) === String(compId) &&
          prev?.name === compName &&
          prev?.CompanyColourCode === compColor
        ) {
          return prev; // No change
        }
        return formatted;
      });

      localStorage.setItem("selectedCompany", JSON.stringify(formatted));
      if (compId) localStorage.setItem("companyId", compId);
      if (compName) localStorage.setItem("companyName", compName);

      window.dispatchEvent(new CustomEvent("companyChanged", { detail: formatted }));
      window.dispatchEvent(new Event("companyChanged"));
      console.log("✅ Global company updated:", formatted);
    } else {
      setSelectedCompany(null);
      localStorage.removeItem("selectedCompany");
      localStorage.removeItem("companyId");
      localStorage.removeItem("companyName");

      window.dispatchEvent(new CustomEvent("companyChanged", { detail: null }));
      window.dispatchEvent(new Event("companyChanged"));
    }
  }, []);

  return (
    <CompanyContext.Provider
      value={{
        selectedCompany,
        setSelectedCompany: updateCompany,
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
};

// ✅ Custom hook for easy use
export const useCompany = () => useContext(CompanyContext);

